import { IExplorableItemTypeInfo, INamedItemInfo, IScheduledItemInfo } from '~src/ts/models/resourceInfoParts';

export interface IPublishedConnectionTaskInfo extends INamedItemInfo, IScheduledItemInfo, IExplorableItemTypeInfo<'extractTask'> {
  lastRunAt?: Date;
  publishedConnection: INamedItemInfo;
  status?: PublishedConnectionTaskStatus;
  tables: ReadonlyArray<IPublishedConnectionTaskTableInfo>;
  extractRefreshLevel: PublishedConnectionExtractRefreshLevel;
}

export enum PublishedConnectionExtractRefreshLevel {
  Table = 'Table',
  Database = 'Database'
}

export enum PublishedConnectionTaskStatus {
  Failed = 'FAILED',
  Succeeded = 'SUCCESS',
}

export interface IPublishedConnectionTaskTableInfo {
  alias: string;
  luid: string;
}
